import React, { useState, useEffect, useRef } from 'react';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import appapi from '../../../api/apiClient';
import { showmessage } from '../../../utils/toastr';
import { useParams, useNavigate } from 'react-router-dom';
import { buttonStyle1 } from '../../../utils/commonStyle';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../redux/features/appSlice';
import FormTextField from '../../../components/FormTextField';
import background from '../../../assets/images/bg.png';
import AuthLayout from '../../../components/AuthLayout';
import LanguageSwitcher from '../../../components/LanguageSwitcher';
import { useTranslation } from 'react-i18next';

/**
 * Validation Schema for register
 */
const validationSchema = yup.object({
  password: yup
    .string('Enter your Password')
    // .min(8, 'Password must be minimum of 6 characters')
    // .max(12, 'Password must be maximum of 12 characters')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/, 'Enter a password of minimum 8 and maximum 20 characters with a combination of capital letters, small letters, symbols, and numbers.')
    .required('Password is requried')
    .trim(),
  reConfirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Password must match')
    .required('Retype Password is requried')
    .trim(),
});

export default function ResetConfirm() {
  const paramsFromUrl = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const formRef = useRef();

  const theme = useTheme();

  const isMobile = useMediaQuery('(max-width:1000px)');

  const [visibility1, setVisibility1] = useState(false);
  const [visibility2, setVisibility2] = useState(false);
  const [data, setData] = useState({
    password: '',
    reConfirmPassword: '',
  });

  const [message, setMessage] = useState({
    status: '',
    msg: '',
  });

  const reset = async (obj) => {
    dispatch(setLoading(true));
    let payload = {
      password: obj.password,
      token: paramsFromUrl.verificationToken,
    };
    const response = await appapi.post(`auth/resetPassword`, payload);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        // showmessage(data.message);
        // navigate('/login');
        setMessage({
          status: 'success',
          msg: 'Your password has been successfully changed. Please click the button below to return to the login page',
        });
      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  /**
   * @returns Redirect to initial page which is login
   */
  const onClickLoginRoute = () => navigate(`/login`);

  const handleVerificationToken = async () => {
    dispatch(setLoading(true));
    const response = await appapi.get(`auth/verifyToken/${paramsFromUrl.verificationToken}`);
    if (response.ok) {
      const data = response.data;
      if (data.status == '7400') {
      } else {
        setMessage({
          status: 'failed',
          msg: data.message,
        });
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  useEffect(() => {
    handleVerificationToken();
  }, []);

  const ResetForm = () => {
    return (
      <>
        <Stack style={{ backgroundColor: '#FFFFFF', borderRadius: '8px' }}>
          <Typography
            className="fw-bold ff-Roboto createHeading !mt-[16px] !mx-[16px]"
            color={theme.palette.primary.text}
            fontSize={'16px'}
          >
            {t('Reset Password')}
          </Typography>
          <Stack style={{ backgroundColor: '#F2F2F2', width: '100%', height: '1px', marginTop: '16px' }} />
          <Typography
            className="ff-Roboto fw-regular !mx-[16px] !mt-[16px]"
            style={{ fontSize: '14px', color: '#14285A' }}
          >
            {t('Please enter your new password and proceed')}
          </Typography>
          <Formik
            innerRef={formRef}
            enableReinitialize={true}
            initialValues={{
              password: data?.password || '',
              reConfirmPassword: data?.reConfirmPassword,
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => reset(values)}
          >
            {({ handleSubmit, values, handleChange, errors, touched, handleBlur, isValid, dirty }) => (
              <Form
                style={{}}
                noValidate
                autoComplete="off"
              >
                <Stack
                  flex={1}
                  className="mt-[16px] mx-[16px]"
                >
                  <FormTextField
                    outlineLabel={t('Password')}
                    name="password"
                    type="password"
                    sx={{ mb: '14px' }}
                    visibility={visibility1}
                    setVisibility={(val) => setVisibility1(val)}
                  />
                </Stack>
                <Stack
                  flex={1}
                  className="mt-[16px] mx-[16px]"
                >
                  <FormTextField
                    outlineLabel={t('Re-type password')}
                    name="reConfirmPassword"
                    type="password"
                    sx={{ mb: '14px' }}
                    visibility={visibility2}
                    setVisibility={(val) => setVisibility2(val)}
                  />
                </Stack>
                <Stack className="px-[16px] pb-[16px]">
                  <Button
                    sx={{
                      ...buttonStyle1,
                      marginBottom: '0',
                      width: '100%',
                      backgroundColor: theme.palette.primary.main,
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                        color: '#fff',
                      },
                      '&:disabled': {
                        color: 'rgba(255,255,255,0.5)',
                        backgroundColor: theme.palette.primary.main,
                      },
                    }}
                    disabled={!(dirty && isValid)}
                    type="submit"
                  >
                    {t('Reset')}
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </>
    );
  };

  return (
    <AuthLayout>
      <Stack
        style={{ maxWidth: '350px', minWidth: '350px' }}
        direction="row"
        alignSelf="center"
      >
        <Stack
          className="leftStack"
          style={{ width: '100%' }}
        >
          <Stack className="formSubmittedStyle mt-28">
            <Stack>
              <Typography
                color={'#FFFFFF'}
                className="fw-medium ff-Roboto"
                style={{ fontSize: '24px', lineHeight: '24px' }}
              >
                {t('CarbonWallet')}
              </Typography>
              <Typography
                color={'#FFFFFF'}
                className="fw-medium ff-Roboto"
                style={{ fontSize: '16px', lineHeight: '24px' }}
              >
               {t('By ZeroEmissions')}
              </Typography>
            </Stack>
            {Boolean(message.status) ? (
              <div>
                <Stack className="bg-white mt-[50px] rounded-[4px] p-[16px]">
                  <Typography
                    className="fw-bold ff-Roboto createHeading !mt-8 !mb-3"
                    color={theme.palette.primary.light}
                  >
                    {message.status ? (message.status === 'success' ? t('Successful') : t('Failed')) : ''}
                  </Typography>
                  <Typography
                    className="fs-12 ff-Roboto fw-regular"
                    color={theme.palette.text.primary.main}
                    style={{ marginBottom: '6px' }}
                  >
                    {t(`${message.msg}`)}
                  </Typography>
                  <Button
                    sx={{
                      ...buttonStyle1,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                      },
                      color: '#fff',
                      textTransform: 'capitalize',
                      marginBottom: '0',
                    }}
                    onClick={onClickLoginRoute}
                    type="submit"
                  >
                    {t('Go Back To Login')}
                  </Button>
                </Stack>
              </div>
            ) : (
              <div style={{ marginTop: '24px' }}>{ResetForm()}</div>
            )}
          </Stack>
        </Stack>
      </Stack>
      <div style={{ position:'absolute', top: '16px', right: '16px'}}>
        <LanguageSwitcher />
      </div>
    </AuthLayout>
  );
}
